import { useState, useEffect } from 'react';
import FormHeader from './FormHeader';
import InputField from './InputField';
import getMonth from './setMonth';
import { toast } from 'react-toastify';

const UpdateDeleteForm = ({
  toggle,
  transactionId,
  fetchTransactions,
  showInfoMonth,
  showInfoCreatedBy,
}) => {
  const [transaction, setTransaction] = useState(null);

  const [type, setType] = useState('');
  const getType = (type) => setType(type);
  const typeInputProps = {
    label: 'Tip',
    type: 'text',
    inputMode: 'text',
    readOnly: true,
    placeholder: 'Tip...',
    value: type,
  };

  const [description, setDescription] = useState('');
  const getDescription = (description) => setDescription(description);
  const descriptionInputProps = {
    label: 'Descriere',
    type: 'text',
    inputMode: 'text',
    readOnly: true,
    placeholder: 'Descriere...',
    value: description,
  };

  const [amount, setAmount] = useState('');
  const getAmount = (amount) => setAmount(amount);
  const amountInputProps = {
    label: 'Suma',
    type: 'text',
    inputMode: 'numeric',
    readOnly: false,
    placeholder: 'Suma...',
    value: amount,
  };

  const { members } = JSON.parse(localStorage.getItem('user'));

  const handleUpdate = async () => {
    if (transaction.createdBy !== members) {
      toast.error('Doar proprietarul poate modifica tranzactia!');
      return;
    }
    const body = { amount: amount.trim() };
    const validationErrors = [];
    if (!body.amount) {
      validationErrors.push('Suma nu este completata!');
    } else if (!/^[1-9][0-9]+$/.test(body.amount)) {
      validationErrors.push('Suma nu este valida!');
    }
    if (validationErrors.length) {
      toast.error(validationErrors[0]);
      return;
    }
    try {
      const res = await fetch(
        `https://api.dcsoft.ro/ext/api/transactions/${transactionId}`,
        {
          method: 'PATCH',
          body: JSON.stringify(body),
          headers: { 'Content-Type': 'application/json' },
        }
      );
      if (!res.ok)
        throw new Error(
          `Error updating data: ${res.status} - ${res.statusText}`
        );
      toast.success('Tranzactia a fost modificata!');
      fetchTransactions(
        transaction.trackerId,
        'all',
        transaction.createdBy,
        getMonth(transaction.createdAt)
      );
      showInfoMonth(getMonth(transaction.createdAt));
      showInfoCreatedBy(transaction.createdBy);
      toggle();
    } catch (error) {
      toast.error('Eroare modificare tranzactie!');
      console.log(error.message);
    }
  };

  const handleDelete = async () => {
    if (transaction.createdBy !== members) {
      toast.error('Doar proprietarul poate sterge tranzactia!');
      return;
    }
    try {
      const res = await fetch(
        `https://api.dcsoft.ro/ext/api/transactions/${transactionId}`,
        { method: 'DELETE' }
      );
      if (!res.ok)
        throw new Error(
          `Error deleting data: ${res.status} - ${res.statusText}`
        );
      toast.success('Tranzactia a fost stearsa!');
      fetchTransactions(
        transaction.trackerId,
        'all',
        transaction.createdBy,
        getMonth(transaction.createdAt)
      );
      showInfoMonth(getMonth(transaction.createdAt));
      showInfoCreatedBy(transaction.createdBy);
      toggle();
    } catch (error) {
      toast.error('Eroare stergere tranzactie!');
      console.log(error.message);
    }
  };

  useEffect(() => {
    const fetchTransaction = async () => {
      try {
        const res = await fetch(
          `https://api.dcsoft.ro/ext/api/transactions/${transactionId}`
        );
        if (!res.ok)
          throw new Error(
            `Error fetching data: ${res.status} - ${res.statusText}`
          );
        const data = await res.json();
        setTransaction(data);
        setType(data.type === 'income' ? 'Venituri' : 'Cheltuieli');
        setDescription(data.description);
        getAmount(data.amount);
      } catch (error) {
        toast.error('Eroare date tranzactie!');
        console.log(error.message);
      }
    };
    fetchTransaction();
  }, [transactionId]);

  return (
    <form className="update-delete-form">
      <FormHeader title={'Modifica/sterge tranzactia'} toggle={toggle} />
      <InputField inputProps={typeInputProps} changeValue={getType} />
      <InputField
        inputProps={descriptionInputProps}
        changeValue={getDescription}
      />
      <InputField inputProps={amountInputProps} changeValue={getAmount} />
      <div className="btn-bar">
        <input
          type="submit"
          className="btn update-form-btn"
          value="Modifica"
          onClick={(e) => {
            e.preventDefault();
            handleUpdate();
          }}
        />
        <input
          type="submit"
          className="btn delete-form-btn"
          value="Sterge"
          onClick={(e) => {
            e.preventDefault();
            handleDelete();
          }}
        />
      </div>
    </form>
  );
};

export default UpdateDeleteForm;
